import React, { useCallback, useEffect, useMemo } from 'react'
import { Form, Row, Spin } from 'antd'
import { isEmpty } from 'lodash'

import {
  DirtyPromptForm,
  FormButtons,
  FormImageUpload,
} from '../../../common/components/sections'
import { PERMISSIONS } from '../../../common/constants'
import { showErrorNotification } from '../../../common/helpers'
import { useFormDirty, useUserHasPermissions } from '../../../common/hooks'

import { useUpdateCuisineTypeImageDetailsMutation } from '../../hooks'
import { cuisineTypePropType } from '../../prop-types'

import { cuisineTypeImageFormInitialValues } from './initial-values'

const CuisineTypeImageDetailsForm = ({ cuisineType }) => {
  const [form] = Form.useForm()

  const isFormEnabled = useUserHasPermissions([
    PERMISSIONS.CUISINE_TYPE.UPDATE_IMAGE_DETAILS,
  ])

  const [
    updateCuisineTypeImageDetails,
    { isLoading: isSaveLoading, error: saveError },
  ] = useUpdateCuisineTypeImageDetailsMutation()

  const initialValues = useMemo(
    () => cuisineTypeImageFormInitialValues(cuisineType),
    [cuisineType],
  )

  const { isDirty, setToDirty, resetForm } = useFormDirty(form)

  const handleSaveData = useCallback(
    data => updateCuisineTypeImageDetails(cuisineType.id, data),
    [cuisineType.id, updateCuisineTypeImageDetails],
  )

  useEffect(() => {
    if (saveError) {
      showErrorNotification({
        title: 'Cuisine Type details error',
        description: saveError,
      })
    }
  }, [saveError])

  useEffect(() => {
    resetForm()
  }, [cuisineType.imageUrl, resetForm])

  return isSaveLoading || isEmpty(initialValues) ? (
    <Spin />
  ) : (
    <>
      <DirtyPromptForm
        isDirty={isDirty}
        form={form}
        initialValues={initialValues}
        name="cuisineTypeImageForm"
        onFinish={handleSaveData}
        autoComplete="off"
        onFieldsChange={setToDirty}
      >
        <Row>
          <FormImageUpload
            disabled={!isFormEnabled}
            labelAbove
            name="image"
            label="Image"
          />
        </Row>
        <FormButtons
          permissions={[PERMISSIONS.CUISINE_TYPE.UPDATE_IMAGE_DETAILS]}
          isDisabled={!isDirty}
          onReset={resetForm}
        />
      </DirtyPromptForm>
    </>
  )
}

CuisineTypeImageDetailsForm.propTypes = {
  cuisineType: cuisineTypePropType.isRequired,
}

export default CuisineTypeImageDetailsForm
